module.exports = __webpack_public_path__ + "media/metronic/_theme/media/illustrations/contact-df6cbe5b8d48bb651ec42a706317385c.svg";